export default __webpack_public_path__ + "static/media/files.c26f92df.svg";